export type InterfaceListingFilter = {
    filter_type: InterfaceFilterTypes,
    tag?: string,
    title: string,
    parentTitle?: string,
    id?: string,
    filter_value?: any,
    filter_value_type: InterfaceFilterValueType,
    asyncSearchSchema?: string,
    asyncSearchField?: string,
    mode?: "single"|"multiple"|"tags",
    placeholder?: string,
    minChars?: number,
    delay?: number,
    closeOnSelect?: boolean,
    filterResults?: boolean,
    resolveOnLoad?: boolean,
    showNoResults?:boolean,
    showNoOptions?:boolean,
    noOptionsText?: string,
    noResultsText?: string,
    searchable?: boolean,
    async?: boolean,
    options?: any,
    fetchOptionsSchema?: string,
    fetchFilterName?: string,
    clearedValue?: InterfaceFilterDefaultValueType,
    urlFilterName?: string,
    dateTypeValue?: string|undefined,
    dateRangeValue?: Array<Date>|undefined
    getFilterParam?:string,
    delimiter?:string,
    isApiSourceStatusFilter?:boolean,
    apiSourceId?:number,
    showNever?: boolean,
}

export enum InterfaceFilterTypes {
    DATES,
    MULTISELECT,
    SEARCH,
    MONTH_DATES,
}

export enum InterfaceFilterValueType {
    VALUE_DATE,
    VALUE_ARRAY,
    VALUE_STRING,
    VALUE_MONTH,
}

export enum InterfaceFilterSchema {
    TMS_ROAD_DOMESTIC = "domestic-shipments",
    TMS_ROAD_INTERNATIONAL = "international-shipments",
    TMS_SEA = "tms-sea-shipments",
    TMS_AIR = "tms-air-shipments",
    WMS_ORDERS = "outbounds",
    WMS_RECEPTIONS = "inbounds",
    VBS_ORDERS = "vbs-report-outbounds",
    VBS_RECEPTIONS = "vbs-report-inbounds",
    ERP_CLIENTS = "customer-ledger-entries",
    CLIENT_USERS = "client-users",
    CONTACTS = "contacts",
    COMPANIES = "companies",
    API_RESOURCE_FIELDS = "api-resource-fields",
    API_ROUTES = "api-routes",
    CLIENT_USER_SESSIONS = "client-user-sessions",
    KLG_USERS = "users",
    LEGAL_HOLIDAYS = "legal-holidays",
    COMPANY_FOR_ALLS = "company-for-alls",
    ACCOUNT_RECEIVABLES = "account-receivables",
    STRONGO = "strongo-shipments",
    APP_STATUSES = "app-statuses",
    KRAKEND_TOKENS = "krakend-tokens",
    KRAKEND_TOKEN_DEMANDS = "krakend-token-demands",
    USER_SESSIONS = "user-sessions",
    ONECLICK_TOKEN_DEMANDS = "oneclick-token-demands",
    ONECLICK_TOKENS = "oneclick-tokens",
    APPLICATION_DEMANDS = "application-demands",
    APPLICATIONS = "applications",
    MCP_TOKENS = "mcp-tokens",
    MCP_TOKEN_ACTIVITIES = "mcp-token-activities",
    CLIENT_MCP_TOKENS = "client-mcp-tokens",
    CLIENT_MCP_TOKEN_ACTIVITIES = "client-mcp-token-activities",
    NOTIFICATIONS = "notifications",
    CLEO_DOCUMENTS = "cleo-documents",
    CLEO_ANALYSIS_FINDINGS = "cleo-analysis-findings",
    ALERTS = "alerts",
    APPLICATION_API_RESOURCE_FIELDS = "application-api-resource-fields",
    APPLICATION_API_ROUTES = "application-api-routes",
}

export enum InterfaceFilterDefaultValueType {
    DEFAULT_EMPTY_STRING,
    DEFAULT_EMPTY_ARRAY,
    DEFAULT_NULL,
    DEFAULT_UNDEFINED,
}

export enum InterfaceFilterMultipleSeparator {
    SEPARATOR = '///',
}